import Vue from 'vue'
import Vuex from 'vuex'

import UserService from '/src/services/user.service.js';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: null,
        uiSettings: null
    },
    mutations: {
        commitCurrentUser(state, user) {
            state.user = user;
            // Se l'utente ha impostazioni UI, le memorizziamo nello stato
            if (user && user.ui_settings) {
                state.uiSettings = user.ui_settings;
            }
            window.localStorage.setItem('user', JSON.stringify(user))
        },
        commitLogout(state) {
            state.user = {
                "id":null,
                "last_login": null,
                "username": null,
                "first_name":null,
                "last_name": null,
                "email":null,
                "date_joined":null,
                "role":"LOGOUT",
                "full_name":null
              }
            state.token = null;
            state.uiSettings = null;
        },
        updateUISettings(state, settings) {
            state.uiSettings = { ...state.uiSettings, ...settings };
            // Aggiorniamo anche le impostazioni nell'oggetto utente
            if (state.user) {
                state.user.ui_settings = { ...state.uiSettings };
                window.localStorage.setItem('user', JSON.stringify(state.user));
            }
        },
    },
    actions: {
        setCurrentUser(context) {
            return UserService.self()
                .then(
                    user => {
                        context.commit('commitCurrentUser', user.data)
                    }
                )
                .catch(
                    () => {
                        context.commit('commitCurrentUser', null)
                        window.localStorage.removeItem('token');
                        // La navigazione deve essere gestita dal componente, non dal store
                    }
                )
        },
        logout(context) {
            return UserService.logout().then(() => {
                context.commit('commitLogout');
                window.localStorage.clear()
            });
        },
        updateUISettings(context, settings) {
            // Prima aggiorniamo lo stato locale
            context.commit('updateUISettings', settings);

            // Poi sincronizziamo con il backend
            return UserService.updateUISettings(settings)
                .then(response => {
                    // Aggiorniamo lo stato con i dati restituiti dal server
                    if (response.data && response.data.ui_settings) {
                        context.commit('updateUISettings', response.data.ui_settings);
                    }
                    return response;
                });
        },
    },
    getters: {
        // Helper methods per controllare i permessi dell'utente corrente
        userPermissions: (state) => {
            if (!state.user || !state.user.role_permissions) {
                return {};
            }
            return state.user.role_permissions;
        },

        canViewExpansion: (state, getters) => {
            const permissions = getters.userPermissions;
            return permissions.can_view_expansion !== false;
        },

        canCreateTasks: (state, getters) => {
            const permissions = getters.userPermissions;
            return permissions.can_create_tasks !== false;
        },

        canDeleteTasks: (state, getters) => {
            const permissions = getters.userPermissions;
            return permissions.can_delete_tasks && permissions.can_delete_tasks !== 'none';
        },

        canDeleteOwnTasks: (state, getters) => {
            const permissions = getters.userPermissions;
            return ['own_only', 'all'].includes(permissions.can_delete_tasks);
        },

        canDeleteAllTasks: (state, getters) => {
            const permissions = getters.userPermissions;
            return permissions.can_delete_tasks === 'all';
        },

        canEditTasks: (state, getters) => {
            const permissions = getters.userPermissions;
            return permissions.can_edit_tasks && permissions.can_edit_tasks !== 'none';
        },

        canEditOwnTasks: (state, getters) => {
            const permissions = getters.userPermissions;
            return ['own_only', 'all'].includes(permissions.can_edit_tasks);
        },

        canEditAllTasks: (state, getters) => {
            const permissions = getters.userPermissions;
            return permissions.can_edit_tasks === 'all';
        },

        canExportData: (state, getters) => {
            const permissions = getters.userPermissions;
            return permissions.can_export_data === true;
        },

        hasProjectAccess: (state, getters) => (project) => {
            const permissions = getters.userPermissions;
            if (permissions.project_access === 'all') {
                return true;
            }
            // Controlla se l'utente è assegnato al progetto
            return project && project.operators &&
                   project.operators.some(op => op.id === state.user.id);
        },

        // Helper per compatibilità con controlli esistenti
        isAdmin: (state) => state.user && state.user.role === 'ADMIN',
        isHead: (state) => state.user && state.user.role === 'HEAD',
        isPurchaseOperator: (state) => state.user && state.user.role === 'PURCHASE_OPERATOR'
    },
    modules: {}
})
